import { BankService } from "@/services";

export default {
  name: "bank-card",
  props: ["card", "isLast"],
  data() {
    return {
      cardModal: false,
      isRequesting: false
    };
  },
  computed: {
    bankName() {
      return this.card.bank_name;
    },

    cardNumber() {
      return this.card.card_number;
    }
  },
  methods: {
    startRequest() {
      this.isRequesting = true;
    },

    finishRequest() {
      this.isRequesting = false;
    },

    closeModal() {
      this.cardModal = false;
    },

    openModal() {
      this.cardModal = true;
    },

    deleteMe() {
      BankService.deleteCard(this.card.id)
        .then(res => {
          this.$emit("delete", this.card.id);
          this.closeModal();
          this.$toast.success(res.data.message);
        })
        .finally(() => this.finishRequest());
      this.startRequest();
    }
  },
  filters: {
    bankFormatter(value) {
      let split = value?.split("");
      const indexes = [4, 9, 14];
      indexes.forEach(index => {
        split?.splice(index, 0, " ");
      });
      return split?.join("");
    }
  }
};
